var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnteNatal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_961_65411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_961_65411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.421875 0.375001H15.6328V15.5859H0.421875V0.375001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_961_65411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24895 5.91767C7.27972 5.42593 6.90676 5.00373 6.41502 4.97233C5.92387 4.94158 5.50076 5.31482 5.46968 5.80626C5.41416 6.69289 5.62447 7.56675 6.06012 8.32031",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69488 10.3106C6.46039 9.54506 6.3841 8.2565 5.46595 7.59527C4.74542 7.07634 3.73443 7.22926 3.10656 7.85712L3.07355 7.89013C2.72548 8.2382 2.72548 8.80252 3.07355 9.15059C3.42162 9.49863 3.98594 9.49863 4.33401 9.15059L4.43446 9.05014L4.44352 9.0622C4.23719 9.33532 3.84907 10.9856 5.06467 12.2012C6.10885 13.2454 7.80181 13.2454 8.84598 12.2012L9.28713 11.7601C10.1287 10.9185 10.5633 9.82415 10.591 8.72147C10.5913 8.70597 10.5916 8.69043 10.5919 8.67492C11.0373 8.5592 11.459 8.32777 11.808 7.97875C12.8522 6.93457 12.8522 5.24161 11.808 4.19744C10.7638 3.15326 9.07088 3.15326 8.0267 4.19744C6.98252 5.24161 6.98252 6.93457 8.0267 7.97875C8.28957 8.24162 8.59355 8.43832 8.91797 8.56886",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02702 15.1406C4.08917 15.1406 0.867188 11.9186 0.867188 7.98079C0.867188 4.04294 4.08917 0.820954 8.02702 0.820954C11.9649 0.820954 15.1869 4.04294 15.1869 7.98079C15.1869 11.9186 11.9649 15.1406 8.02702 15.1406Z",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22656 2.7024C3.38209 2.97489 3.51168 3.26387 3.61236 3.56592C3.94635 4.56788 4.59843 5.42602 5.46037 6.01562",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_961_65411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2109,
    height: 15.2109,
    fill: "white",
    transform: "translate(0.414062 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnteNatal);
export default __webpack_public_path__ + "static/media/ante-natal.7a1a607da1c22786f00642ded3a7745a.svg";
export { ForwardRef as ReactComponent };